import React, { useState } from "react";
import { Bar } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const QualityChart = ({ selected, barData, refinedLabel, label: legend }) => {
  const [label] = useState(refinedLabel);
  const [data] = useState(barData);

  const chartData = {
    labels: label,
    datasets: [
      {
        label: legend,
        data: data,
        backgroundColor: "rgba(35, 171, 185, 1)",
        borderColor: "2px solid transparent",
        borderWidth: 1,
        borderRadius: 3,
        barPercentage: 1,
        categoryPercentage: 1,
        barThickness: "flex", // Set bar thickness as flexible
        categorySpacing: 4,
      },
    ],
  };

  const chartOptions = {
    indexAxis: "x",
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          font: {
            weight: "bold", // Set font weight to bold
            size: 8,
          },

          color: "#B5B9C0", // Set label color to white
          align: "inner", // Align labels to the start (left)
          labelOffset: 10,
        },
        grid: {
          color: "transparent",
        },
        border: {
          width: 2,
          color: "#0B1830",
        },
      },

      y: {
        beginAtZero: true,
        ticks: {
          font: {
            // weight: "bold", // Set font weight to bold
          },
          color: "#B5B9C0",
          align: "inner",
          weight: "bold",
          stepSize: 5,
        },

        grid: {
          color: "#545D6E",
          lineWidth: 0.25,
        },

        border: {
          width: 2,
          color: "#0B1830",
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  const alternatingBackgroundPlugin = {
    id: "alternatingBackgroundPlugin",
    beforeDraw: (chart) => {
      const ctx = chart.ctx;
      const xAxis = chart.scales.x;
      const chartArea = chart.chartArea;

      // Colors to alternate
      const colors = ["#18243b", "#232f43"];

      // Calculate the width for each section
      const sectionWidth =
        (chartArea.right - chartArea.left) / xAxis.ticks.length;

      ctx.save();
      for (let i = 0; i < xAxis.ticks.length; i++) {
        ctx.fillStyle = colors[i % colors.length];
        let x = chartArea.left + i * sectionWidth;
        let width =
          i === xAxis.ticks.length - 1 ? chartArea.right - x : sectionWidth;
        ctx.fillRect(x, chartArea.top, width, chartArea.bottom - chartArea.top);
      }
      ctx.restore();
    },
  };

  Chart.register(alternatingBackgroundPlugin);

  return (
    <div className="m-auto text-center w-full ">
      <Bar data={chartData} options={chartOptions} height={180} />
      <p className="months-bar mt-3">
        <span className="cursor-pointer"> {"< "} &nbsp;</span>
        {selected || "Month"}{" "}
        <span className="cursor-pointer">&nbsp;{">"}</span>
      </p>
    </div>
  );
};

export default QualityChart;
